/*
 * @Author: ylq
 * @Date: 2022-09-20 16:23:33
 * @Desc: Store
 * @Last Modified by: ylq
 * @Last Modified time: 2023-07-03 17:13:14
 */
import { createPinia } from 'pinia';
import useUserStore from './modules/user';
import useAppStore from './modules/app';
import useChatStore from './modules/chatGpt';
import useCalendarStore from './modules/calendar'; //日历看板
import useContactsStore from './modules/contacts'; //联系人
import useCalllogStore from './modules/calllog'; //通话记录
import useFollowRecords from './modules/followRecords'; //动态记录
import useScheduleStore from './modules/schedule'; //日程
import useLayoutStore from './modules/layout'; //布局
import usePricesheetStore from './modules/priceSheet'; //报价单
import useContractStore from './modules/contract'; //合同
import useOrderStore from './modules/order'; //合同
import useCustomStore from './modules/customObject'; //系统对象
import useSettingStore from './modules/settings'; // 设置
import useFilterListStore from './modules/filterList'; // 筛选记录
import useConditionStore from './modules/condition'; // 条件组件
import useOutCallStore from './modules/outCall'; // 外呼
import useFieldPermissionRulesStore from './modules/fieldPermissionRules'; // 字段权限规则
import useMainTableStore from './modules/mainTable'; //主表格方法信息
import useMigrationToolsStore from './modules/migrationTools'; // 迁移工具
import useGrayscaleStore from './modules/grayscale'; //灰度
import useUploadStore from './modules/upload'; //上传组件
import useFormTableStore from './modules/formTable'; //表单关联数据

const pinia = createPinia();

export { useUserStore, useAppStore, useChatStore, useCalendarStore, useContactsStore, useCalllogStore, useFollowRecords, useLayoutStore, useScheduleStore, usePricesheetStore, useContractStore, useOrderStore, useSettingStore, useCustomStore, useFilterListStore, useConditionStore, useOutCallStore, useFieldPermissionRulesStore, useMainTableStore, useMigrationToolsStore, useGrayscaleStore, useUploadStore, useFormTableStore };
export default pinia;
